import React from "react";
import { StoreButtons } from "./buttons";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { Button } from "@speedoc/design-assets";

const DownloadMobileApps = ({ content }) => {
  const { title, subtitle, text, desktopImage, mobileImages, qrCodeImage } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const downloadLink = useAppDownloadLink();

  const settings = {
    infinite: true,
    fade: false,
    autoplaySpeed: 5000,
    autoplay: false,
    dots: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <div id="downLoadAppV4">
      <div className="grid">
        <div className="left">
          {title && <div className="title" dangerouslySetInnerHTML={{ __html: title }} />}
          {!isMobile && (
            <>
              <div className="description">{subtitle && <div className="textBody">{subtitle}</div>}</div>
              <div className="links">
                {qrCodeImage?.url && <img className="qrCode" alt="QR code" src={qrCodeImage?.url} />}
                <div className="wrapper">
                  {text && <div className="smallText">{text}</div>}
                  <StoreButtons />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="right">
          {isMobile && mobileImages?.length ? (
            <>
              <Slider {...settings}>
                {mobileImages.map(({ media }, index) => (
                  <div key={index}>
                    <LazyLoadImage src={media.url} alt="slide" effect="blur" />
                  </div>
                ))}
              </Slider>
              <div className="description">{subtitle && <div className="textBody">{subtitle}</div>}</div>
              <div className="button">
                <Button className="btnDownload">
                  <a className="button secondary sm" href={downloadLink}>
                    <span>{"Download the App"}</span>
                  </a>
                </Button>
              </div>
            </>
          ) : (
            <>{desktopImage.url && <LazyLoadImage src={desktopImage.url} alt="download" effect="blur" />}</>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadMobileApps;
